import {Component, Injector, ViewEncapsulation} from "@angular/core";
import {BaseComponent} from "../../../ui/components/base/base.component";

@Component({
  selector: 'emissao-menu-page',
  templateUrl: './emissao.menu.page.component.html',
  styleUrls: ['./emissao.menu.page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmissaoMenuPageComponent extends BaseComponent {

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.navigate("/home/actions/emissaonf2");
  }
}
